import state from './reports.state'
import mutations from './reports.mutations'
import actions from './reports.actions'
import getters from './reports.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
